import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DataTitle } from '../DataTitle';
import { NavigateTo } from '../NavigateTo';

interface IUserInformation {
  userInfo: {
    fullName: string;
    id: string;
    caseNumber: string;
    familyStatus: string;
  };
  isRecognized: boolean;
  haveFamilyMembers: boolean;
}

export const UserInformation = (props: IUserInformation) => {
  const isDesktop = useIsDesktop();
  // Keys are used in order to pull the title from the dict generally.
  const dataKeys = Object.keys(props.userInfo);
  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  return (
    <Stack gap={'24px'}>
      <Stack
        direction='row'
        justifyContent='flex-start'
        flexWrap={'wrap'}
        gap={isDesktop ? '40px' : '20px 10px'}
      >
        {[
          props.userInfo?.fullName,
          props.userInfo?.id,
          props.userInfo?.caseNumber,
          props.userInfo?.familyStatus,
        ].map((item: string, index: number) => {
          return (
            <Stack key={index} direction='column' width={'136px'}>
              <DataTitle
                dataTitle={dictionary.userGeneralInformation[dataKeys[index]]}
                data={item}
              />
            </Stack>
          );
        })}
      </Stack>
      {props.isRecognized && (
        <NavigateTo
          href='/disabled-veteran'
          label={Dictionary[DICTIONARY.DisabledVeteran].watchCard}
        />
      )}
    </Stack>
  );
};
